import script from "./MenusComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenusComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenusComponent.vue?vue&type=style&index=0&id=c12b63be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c12b63be"]])

export default __exports__